/// <amd-module name="VSS/Redux/Modules/Telemetry/TelemetryActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";

export const enum TelemetryActionTypes {
    EndScenario = "Telemetry/EndScenario",
}

export const TelemetryActions = {
    endScenario: (scenarioName: string, properties?: {[key: string]: any}, isPageInteractive: boolean = false) => createAction(TelemetryActionTypes.EndScenario, { scenarioName, isPageInteractive, properties }),
}

export type TelemetryAction = ActionsUnion<typeof TelemetryActions>;
